import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { X, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Standardized modal component with blur backdrop and optional draft persistence
 * Sizes: sm (400px), md (600px), lg (800px), xl (90vh scrollable)
 */
const StandardModal = ({ 
  isOpen, 
  onClose, 
  title, 
  description,
  children,
  footer,
  size = 'md', // sm, md, lg, xl
  showCloseButton = true,
  closeOnOutsideClick = true,
  persistKey, // If provided, will show draft indicator
  hasDraft = false
}) => {
  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl'
  };

  return (
    <Dialog 
      open={isOpen} 
      onOpenChange={(open) => {
        if (!open && closeOnOutsideClick) {
          onClose();
        }
      }}
    >
      <DialogContent className={`${sizeClasses[size]} max-h-[90vh] flex flex-col`}>
        <DialogHeader className="flex-shrink-0">
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <DialogTitle>{title}</DialogTitle>
                {hasDraft && (
                  <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full font-medium">
                    Draft Restored
                  </span>
                )}
              </div>
              {description && <DialogDescription className="mt-1">{description}</DialogDescription>}
            </div>
          </div>
        </DialogHeader>
        
        {/* Modal Body - Scrollable */}
        <div className="mt-4 overflow-y-auto flex-1 px-1">
          {children}
        </div>

        {/* Modal Footer */}
        {footer && (
          <div className="flex flex-col-reverse sm:flex-row justify-end gap-2 pt-4 border-t mt-6 flex-shrink-0">
            {footer}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default StandardModal;

